import { useV2FAQsControllerGetMainCategories, useV2FAQsControllerGetMiddleCategories, type V2FaqMainCategoryResponseDto, type V2FaqMiddleCategoryResponseDto } from "@everon-it/api-client/contents-gw";
import { useEffect, useState } from "react";
import { type CommonOptionType } from "src/types/common";

const INIT_CATEGORY_OPTION: CommonOptionType = { label: "전체", value: "" };

export const useFetchFaqCategoryOption = (selectedCategoryCode?: string) => {
    const [categoryOption, setCategoryOption] = useState<CommonOptionType[]>([]);

    // 대분류 조회 (selectedCategoryCode가 없을 때)
    const { data: mainCategoryData } = useV2FAQsControllerGetMainCategories({
        query: {
            enabled: !selectedCategoryCode,
            retry: false,
            refetchOnWindowFocus: false,
        },
    });

    // 중분류 조회 (selectedCategoryCode가 있을 때)
    const { data: middleCategoryData } = useV2FAQsControllerGetMiddleCategories(
        { mainCategory: selectedCategoryCode ?? "" },
        {
            query: {
                enabled: !!selectedCategoryCode,
                retry: false,
                refetchOnWindowFocus: false,
            },
        },
    );

    // 대분류/중분류 데이터 변경 시 옵션 통합 업데이트
    useEffect(() => {
        const rows = selectedCategoryCode ? middleCategoryData?.rows : mainCategoryData?.rows;

        if (rows) {
            setCategoryOption([
                INIT_CATEGORY_OPTION,
                ...rows.map((item: V2FaqMainCategoryResponseDto | V2FaqMiddleCategoryResponseDto) => ({
                    label: item.description,
                    value: item.code,
                })),
            ]);
        }
    }, [mainCategoryData, middleCategoryData, selectedCategoryCode]);

    return { categoryOption, setCategoryOption };
};
